import { useEffect, useState } from "react";

const scrollParent = (el) => {
  for (let n = el?.parentElement; n; n = n.parentElement) {
    const oy = getComputedStyle(n).overflowY;
    if ((oy === "auto" || oy === "scroll") && n.scrollHeight > n.clientHeight) return n;
  }
  return document.scrollingElement || document.documentElement;
};

// Wheel over the left `fraction` of the element always scrolls the page, never the card under the mouse.
export default function usePageScrollLane(fraction = 0.25) {
  const [node, setNode] = useState(null);
  useEffect(() => {
    if (!node) return undefined;
    const onWheel = (e) => {
      if (e.ctrlKey || !e.deltaY) return;
      const rect = node.getBoundingClientRect();
      if (e.clientX - rect.left > rect.width * fraction) return;
      const dy = e.deltaMode === 1 ? e.deltaY * 16 : e.deltaMode === 2 ? e.deltaY * window.innerHeight : e.deltaY;
      scrollParent(node).scrollBy({ top: dy });
      e.preventDefault();
    };
    node.addEventListener("wheel", onWheel, { passive: false });
    return () => node.removeEventListener("wheel", onWheel);
  }, [node, fraction]);
  return setNode;
}
